module.exports = __webpack_public_path__ + "img/aboutusbanner.fc624e83.png";